module.exports = __webpack_public_path__ + "static/media/exercise-video-image@3x.09b30a42.jpg";